import React from 'react';
import { normalizePremiumFolderData } from '../../../../../../utils/normalizePremiumFolderData';
import { useSubscriptionTier } from '../../../../../../utils/hooks/useSubscriptionTier';
import PaidThumbPaywall from './PaidThumbPaywall';
import WatchersOnlyThumbPaywall from './WatchersOnlyPaywall';
import SubscriberThumbPaywall from './SubscriberThumbPaywall';
var ThumbPaywall = function (_a) {
    var deviation = _a.deviation, className = _a.className, isSmall = _a.isSmall;
    var _b = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), isPaidFolder = _b.isPaidFolder, isWatchToAccess = _b.isWatchToAccess;
    var needsSubscription = useSubscriptionTier(deviation).needsSubscription;
    return (React.createElement(React.Fragment, null,
        isPaidFolder && (React.createElement(PaidThumbPaywall, { deviation: deviation, isSmall: isSmall, className: className })),
        isWatchToAccess && (React.createElement(WatchersOnlyThumbPaywall, { deviation: deviation, isSmall: isSmall, className: className })),
        needsSubscription && (React.createElement(SubscriberThumbPaywall, { deviation: deviation, isSmall: isSmall, className: className }))));
};
ThumbPaywall.displayName = 'ThumbPaywall';
export default ThumbPaywall;
//# sourceMappingURL=ThumbPaywall.js.map